import { render, staticRenderFns } from "./FinTransfer.vue?vue&type=template&id=3d510326&"
import script from "./FinTransfer.vue?vue&type=script&lang=js&"
export * from "./FinTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports